/**
 * Typed API methods for themes plugin.
 */
import { request } from '@reflex/ui/client/http';

export interface CustomTheme {
  id: string;
  name: string;
  label: string;
  source: string;
  cssVars: { light: Record<string, string>; dark: Record<string, string> };
  createdAt: number;
}

export interface TweakcnCatalogTheme {
  name: string;
  label: string;
  previewColor: string | null;
}

export function getCustomThemes(): Promise<CustomTheme[]> {
  return request<CustomTheme[]>('/settings/themes');
}

export function getDefaultTheme(): Promise<{ themeId: string }> {
  return request<{ themeId: string }>('/settings/default-theme');
}

export function setDefaultTheme(themeId: string): Promise<{ themeId: string }> {
  return request<{ themeId: string }>('/settings/default-theme', {
    method: 'PUT',
    body: JSON.stringify({ themeId }),
  });
}

export function importTweakcnTheme(tweakcnName: string): Promise<CustomTheme> {
  return request<CustomTheme>('/settings/themes', {
    method: 'POST',
    body: JSON.stringify({ tweakcnName }),
  });
}

export function deleteCustomTheme(id: string): Promise<{ ok: boolean }> {
  return request<{ ok: boolean }>(`/settings/themes/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}

export function getTweakcnCatalog(): Promise<TweakcnCatalogTheme[]> {
  return request<TweakcnCatalogTheme[]>('/settings/tweakcn-catalog');
}
